export default __webpack_public_path__ + "static/media/roadmap_flow.38926882.png";